import PropTypes from 'prop-types';
import React from 'react';
import { Redirect, Route, useLocation } from 'react-router-dom';

import AuthLayout from '~/pages/_layouts/auth';
import DefaultLayout from '~/pages/_layouts/default';
import { store } from '~/store';

export function RouteWrapper({ component: Component, isPrivate, ...rest }) {
  const { signed, permissions } = store.getState().auth;

  const locationUrl = useLocation();

  if (locationUrl.pathname !== '/' && permissions.length > 0 && !permissions.includes(locationUrl.pathname.split('/')[1])) {
    return <Redirect to="/dashboard" />;
  }

  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }

  if (signed && !isPrivate) {
    return <Redirect to="/dashboard" />;
  }

  const Layout = signed ? DefaultLayout : AuthLayout;

  return (
    <Route
      {...rest}
      render={(props) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

RouteWrapper.defaultProps = {
  isPrivate: false,
};
